import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { createSelector } from 'reselect';
import { useAliveController } from 'react-activation';
import styles from './ForumBar.module.less';
import { CONTEXT } from '../../../config';
import { logging } from '../../../actions/log';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default function ForumBar() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { dropScope, refresh } = useAliveController();
  const logInfoData = useSelector(selectLogInfo);

  useEffect(() => {}, []);

  const handleChangePage = useCallback(
    (page, type) => {
      dropScope(page);
      if (page === 'forumlist' && history.location.pathname.indexOf('forumlist') > -1) {
        refresh(page);
      }

      dispatch(
        logging({
          category: 'C',
          action: 'Forum_Bar_Change_Page',
          label: '',
          param2: {
            source: 'Forum_Bar',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            page,
            type,
          },
        }),
      );

      let url = `${CONTEXT}/${page}`;
      if (page === 'formpublish') {
        url = `${CONTEXT}/${page}?type=${type}`;
      }
      setTimeout(() => {
        history.push(url);
      }, 50);
    },
    [history],
  );

  return (
    <div className={styles.forum}>
      <div className={styles.forumbar}>
        <div
          className={styles.forumbar_logo}
          onClick={() => {
            handleChangePage('forumlist');
          }}
        ></div>
        <div className={styles.forumbar_opt}>
          <div className={styles.forumbar_pub}>
            <div className={styles.forumbar_pub_icon}></div>
            <div className={styles.forumbar_text}>发表</div>
            <div className={styles.pub}>
              <div
                className={styles.pub_quest}
                onClick={() => {
                  handleChangePage('formpublish', '1');
                }}
              >
                <div className={`${styles.pub_quest_img} iconfont icon-fquest`}></div>
                <div className={styles.pub_title}>我要提问</div>
                <div className={styles.pub_desc}>关于软件，我有问题要提问</div>
              </div>
              <div
                className={styles.pub_share}
                onClick={() => {
                  handleChangePage('formpublish', '2');
                }}
              >
                <div className={`${styles.pub_share_img} iconfont icon-fshare`}></div>
                <div className={styles.pub_title}>我要分享</div>
                <div className={styles.pub_desc}>我有好用软件/实用技能要分享</div>
              </div>
            </div>
          </div>
          <div
            className={styles.forumbar_mine}
            onClick={() => {
              handleChangePage('forumlistpublish');
            }}
          >
            <div className={styles.forumbar_mine_icon}></div>
            <div className={styles.forumbar_text}>我的</div>
          </div>
        </div>
      </div>
      {(location.pathname.indexOf(`${CONTEXT}/forumlistpublish`) > -1 ||
        location.pathname.indexOf(`${CONTEXT}/forumlistcollect`) > -1) && (
        <div className={styles.forum_menu}>
          <div
            className={
              location.pathname.indexOf(`${CONTEXT}/forumlistpublish`) > -1
                ? styles.forum_menu_active
                : styles.forum_menu_item
            }
            onClick={() => {
              handleChangePage('forumlistpublish');
            }}
          >
            我的帖子
          </div>
          <div
            className={
              location.pathname.indexOf(`${CONTEXT}/forumlistcollect`) > -1
                ? styles.forum_menu_active
                : styles.forum_menu_item
            }
            onClick={() => {
              handleChangePage('forumlistcollect');
            }}
          >
            我的收藏
          </div>
          {/* <div className={styles.forum_menu_item}>我的消息</div> */}
        </div>
      )}
    </div>
  );
}
